import { inject, Injectable } from '@angular/core';
import { IDesktopNotificationPayload } from '@dxp/core/models';
import { DesktopNotificationService } from './desktop-notification.service';

@Injectable({
    providedIn: 'root',
})
export abstract class DesktopNotifierBaseService {
    readonly #notificationService = inject(DesktopNotificationService);

    protected notify(payload: IDesktopNotificationPayload): string | null {
        return this.#notificationService.showNotification(payload);
    }

    protected closeNotification(id: string) {
        this.#notificationService.clearNotification(id);
    }
}
